export const LOGISTICS_CONFIGURATIONS_RESET_STATE = 'LOGISTICS_CONFIGURATIONS_RESET_STATE';
export const LOGISTICS_CONFIGURATIONS_CURRENT_ITEM = 'LOGISTICS_CONFIGURATIONS_CURRENT_ITEM';

export const LOGISTICS_CONFIGURATIONS_REQUEST_LOADING = 'LOGISTICS_CONFIGURATIONS_REQUEST_LOADING';
export const LOGISTICS_CONFIGURATIONS_REQUEST_SUCCESS = 'LOGISTICS_CONFIGURATIONS_REQUEST_SUCCESS';
export const LOGISTICS_CONFIGURATIONS_REQUEST_FAILED = 'LOGISTICS_CONFIGURATIONS_REQUEST_FAILED';

export const LOGISTICS_CONFIGURATIONS_CURRENT_ACTION = 'LOGISTICS_CONFIGURATIONS_CURRENT_ACTION';
export const LOGISTICS_CONFIGURATIONS_RESET_ACTION = 'LOGISTICS_CONFIGURATIONS_RESET_ACTION';